import React, { useCallback } from "react";
import { square } from "ionicons/icons";
import {
  IonCard,
  IonLabel,
  IonText,
  IonSkeletonText,
  IonChip,
  IonRouterLink,
  IonImg,
  IonButtons,
  IonCardContent,
  IonTitle,
  IonToolbar,
  IonIcon,
  IonCol,
  IonRow,
  IonGrid,
} from "@ionic/react";
import styles from "./ChallengeCard.module.css";
import { ChallengeActionButtons } from "./ChallengeActionButtons";
import { usePersistedState, States } from "./usePersistedState";
import { Routes } from "../../routes";

interface ChallengeCardProps {
  guid: string;
  title?: string;
  subtitle?: string;
  theme?: string;
  imageSrc?: string;
  hideStartButton?: boolean;
}

export const ChallengeCard: React.FC<ChallengeCardProps> = ({
  guid,
  title,
  subtitle,
  theme,
  imageSrc,
  hideStartButton = false,
}) => {
  const [storedValue] = usePersistedState(guid, States.Incomplete);
  console.log("stored", guid, storedValue);

  const getChallengeStateColour = useCallback(() => {
    if (storedValue === States.Complete) {
      return "success";
    } else if (storedValue === States.InProgress) {
      return "warning";
    } else if (storedValue === States.Incomplete) {
      return "secondary";
    }
  }, [storedValue]);

  return (
    <IonCard className={styles.card}>
      {imageSrc && (
        <div className={styles.imageContainer}>
          <IonImg
            className={styles.featureImage}
            src={imageSrc}
            alt="challenge feature image"
          />
        </div>
      )}
      <IonCardContent className={styles.cardContent}>
        <IonGrid class="ion-no-padding">
          <IonRow>
            <IonCol className="ion-justify-content-start" size="11">
              {guid === "" ? (
                <IonLabel className={`ion-text-wrap ${styles.skeleton}`}>
                  <IonSkeletonText animated style={{ width: "60%" }} />
                  <IonSkeletonText animated />
                  <IonSkeletonText animated style={{ width: "80%" }} />
                </IonLabel>
              ) : (
                <>
                  <IonTitle
                    className={`ion-no-padding ${styles.title}`}
                    color="dark"
                    size="small"
                  >
                    {title}
                  </IonTitle>
                </>
              )}
            </IonCol>
            <IonCol className="ion-justify-content-end">
              <IonIcon
                float-right
                icon={square}
                color={getChallengeStateColour()}
              />
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonText color="dark">
          <p className={styles.subtitle}>{subtitle}</p>
        </IonText>
      </IonCardContent>
      <IonToolbar className={styles.cardButtons}>
        {theme && (
          <IonButtons slot="end">
            <IonRouterLink
              color={getChallengeStateColour()}
              href={`#${Routes.ThemesPage}/${theme}`}
            >
              <IonChip outline color="secondary">
                {theme}
              </IonChip>
            </IonRouterLink>
          </IonButtons>
        )}
        {!hideStartButton && <ChallengeActionButtons guid={guid} />}
      </IonToolbar>
    </IonCard>
  );
};
